import React from 'react'
import {
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  Button,
  PinPointInput,
  FormRow,
} from '../'
import { formUpdater, inputNormalizer, useViewport } from '../../utils'
import { ProvinceSelect } from './location-popup-province-select'
import { ProvincesProvider } from '../../features/provinces/hook'
import { CitiesProvider } from '../../features/cities/hook'
import { CitySelect } from './location-popup-city-select'
import { AlertError } from '../alert'

const LocationForm = ({ onSave, locationToEdit, onCancel }) => {
  const { isMobile } = useViewport()
  const [location, setLocation] = React.useState(locationToEdit ? locationToEdit : {})
  const [errorMessage, setErrorMessage] = React.useState(null)
  const updateLocation = (e) => formUpdater(e, location, setLocation)

  const handleCancel = (e) => {
    if(e){
      e.preventDefault()
      e.stopPropagation()
    }

    if(typeof onCancel === 'function'){
      onCancel(false)
    }
  }

  const validateForm = () => {
    const {
      _city,
      _province,
      address,
      pin_point
    } = location

    let msg = ''

    if(!_city){
      msg += 'City is required. '
    }

    if(!_province){
      msg += 'Province is required. '
    }

    if(!address){
      msg += 'Address is required. '
    }

    if(!pin_point){
      msg += 'Pin Point is required. '
    }

    if(msg !== ''){
      setErrorMessage(msg)
    }

    return _city && _province && address && pin_point
  }

  const handleSave = (e) => {
    e.preventDefault()
    e.stopPropagation()

    setErrorMessage(null)

    const {
      _city,
      _province
    } = location

    if(validateForm()){
      const cloned = {...location}
      cloned.city = _city.label
      cloned.province = _province.label

      if(typeof onSave === 'function'){
        onSave(cloned)
      }
    }
  }

  const handlePinPoint = (value) => {
    const result = `${value.lat}, ${value.lng}`
    inputNormalizer(result, 'pin_point', updateLocation)
  }

  const handleSelect = (type, e) => {
    setLocation({
      ...location,
      [type]: e.value
    })

    updateLocation({
      target: {
        name: '_'+type,
        value: e
      }
    })
  }

  return (
    <div>
      <div className="flex flex-wrap -mx-4 mb-5 lg:mb-8">
        <div className="w-full lg:w-1/2 px-4 mb-5 lg:mb-0">
          <ProvincesProvider>
            <ProvinceSelect
              defaultValue={{label: location.province, value: location.province}}
              onChange={(e) => handleSelect('province', e)}
            />
          </ProvincesProvider>
        </div>
        <div className="w-full lg:w-1/2 px-4">
          {
            (location._province && location._province.value) ? (
              <CitiesProvider provinceId={location._province.value}>
                <CitySelect
                  defaultValue={{label: location.city, value: location.city}}
                  onChange={(e) => handleSelect('city', e)}
                />
              </CitiesProvider>
            ) : (
              <p className="text-sm text-gray-600">
                Please select province first.
              </p>
            )
          }
        </div>
      </div>
      <FormRow>
        <Label>Address</Label>
        <Input
          className="w-full"
          defaultValue={location.address}
          name="address"
          onChange={updateLocation}
        />
      </FormRow>
      <FormRow last>
        <Label>Pin Point</Label>
        <PinPointInput
          value={location.pin_point}
          onChange={handlePinPoint}
        />
      </FormRow>
      <div className="flex flex-wrap items-center">
        <Button
          style={{maxWidth: isMobile ? '100%' : '197px'}}
          thin={isMobile ? true : false}
          className="mb-5 lg:mb-0"
          onClick={handleSave}
        >
          Save
        </Button>
        <div
          className="text-center lg:text-left w-full lg:w-auto text-xs lg:text-sm text-gray-444 underline lg:ml-8 cursor-pointer"
          onClick={handleCancel}
        >
          Cancel
        </div>
      </div>
      {
        errorMessage !== null &&
        <AlertError message={errorMessage} onClose={() => setErrorMessage(null)}/>
      }
    </div>
  )
}

export { LocationForm }
